import { isJDJR } from '@/utils/channel'
import { reportSGM } from '@/utils/sgm'
import { JDJR_OPENAPP_LINK_HOME } from '@/config/jsBridge'
import { SGM_TYPE } from '@/utils/sgm'

/**
 * @description 调用关闭Webview方法
 */
export function closeWebviewInJDJR(next: Function) {
  if (!isJDJR) return next()
  if (!JrBridge || typeof JrBridge.closeView !== 'function') {
    reportSGM({
      code: 'CLOSE_WEBVIEW_IN_JDJR_ERROR',
      desc: 'JrBridge init error',
    })
    return
  }
  JrBridge.closeView()
}

/**
 * @description 调用跳转首页方法
 */
export function jumpToJDJRIndexWebview(next: Function) {
  if (!isJDJR) return next()
  reportSGM({
    type: SGM_TYPE.Info,
    code: 'JUMP_INTO_APP_INDEX',
    desc: '【金融App】调用跳转首页桥方法',
  })
  window.location.href = JDJR_OPENAPP_LINK_HOME
}

/**
 * @description 回退
 */
export function goBackInJDJR(next: Function) {
  if (!isJDJR) return next()
  if (!JrBridge || typeof JrBridge.callNative !== 'function') {
    reportSGM({
      code: 'GO_BACK_IN_JDJR_ERROR',
      desc: 'JrBridge init error',
    })
    return
  }
  JrBridge.callNative({
    type: '82',
  })
}

/**
 * @description 获取京东金融App版本号
 */
export function getAppVersionInJDJR(next: Function) {
  if (!isJDJR) return next()
  const ua = ((navigator && navigator.userAgent) || '').toLowerCase()
  try {
    const version = (/clientversion=([^&]*)/.exec(ua) || [])[1]
    return version
  } catch (error) {
    return ''
  }
}

export function hideNavigationBarMoreSettingInJDJR(
  title: string,
  next: Function
) {
  if (!isJDJR) return next()
  if (!JrBridge || typeof JrBridge.callNative !== 'function') {
    reportSGM({
      code: 'HIDE_NAVIGATION_BAR_IN_JDJR_ERROR',
      desc: 'JrBridge init error',
    })
    return
  }
  JrBridge.setTopBar({
    version: 100, //version 必传 固定字符100
    title, //要设置的页面标题
    moreItem: false, //是否显示更多按钮 true-显示 false-隐藏
  })
}
